module.exports = __webpack_public_path__ + "static/media/nodata.dff1f8a6.png";